<template>
  <div :class="[$style.part, $style[`part_${data.id}`]]">
    <div :class="$style.part_wrap">
      <h3 :class="$style.title">{{ data.title }}</h3>
      <div
        v-for="(el, index) in data.content"
        :key="index"
        :class="[
          $style.item,
          $style[`item_${el.icon_row}_${el.icon_col}`],
          active.length > 0 &&
            active[0] === data.id &&
            active[1] === index &&
            $style.item_active,
        ]"
        @click="onClick([data.id, index])"
      >
        {{ el.title }}
        <div :class="$style.tip">
          <div>{{ el.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    active: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return { touchActive: null }
  },
  methods: {
    onClick(data) {
      if (document.body.ontouchstart !== undefined) {
        this.$emit('tap', data)
      }
    },
  },
}
</script>

<style lang="less" module>
@border-color: #e3e3e3;
@hover-background-color: #f8f8f8;
@bubble-background-color: #e5eefe;
@bubble-color: #376db1;

@padding: 3.6rem;
@padding-line: @padding - 0.5;
@line-bottom: 9.19rem;
@icon-size: 0.88rem;

.part-active() {
  display: block;
  transform-origin: 50% 100%;
  animation: bounce 0.3s both;
}

@keyframes bounce {
  from {
    transform: translate(-50%, 0.05rem);
  }

  50% {
    transform: translate(-50%, -0.05rem);
  }

  to {
    transform: translate(-50%, 0);
  }
}

.part-zoom(@r) {
  // 左侧边
  &::before {
    left: @padding-line - @r;
  }

  &:hover {
    // 左侧刻度线
    &::after {
      left: @padding-line - @r;
    }
  }

  &_wrap {
    margin-left: @padding - @r;
    margin-right: @padding - @r;

    .part:not(:last-child) & {
      &::before {
        width: @line-bottom + @r * 2;
      }
    }
  }
}

.part {
  position: relative;

  // 左侧边
  &::before {
    .size(1px, 100%);
    content: '';
    position: absolute;
    top: 0;
    left: @padding-line;
    background-color: @border-color;
  }

  &:hover {
    background-color: @hover-background-color;

    // 左侧刻度线
    &::after {
      .size(0.3rem, 0.02rem);
      content: '';
      position: absolute;
      top: 1.02rem;
      left: @padding-line;
      background-color: @border-color;
    }
  }

  &_wrap {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 2.3rem;
    margin-left: @padding;
    margin-right: @padding;

    .part:not(:last-child) & {
      &::before {
        .size(@line-bottom, 1px);
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: @border-color;
      }
    }
  }
}

.title {
  .subtitle-size(1.95rem, 0.6rem);
  .text-hide();
  background: url('./images/welfare-item-title.png') no-repeat;
  background-size: 400% 200%;

  .loop(@n) when (@n <= 4) {
    .part_@{n} & {
      .sprites-position-x(780, 195, 195 * (@n - 1));
    }

    .part_@{n}:hover & {
      .sprites-position-x(780, 195, 195 * (@n - 1), 100%);
    }

    .loop(@n + 1);
  }
  .loop(1);
}

.item {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 8em;
  cursor: default;

  &::before {
    .size(@icon-size);
    content: '';
    display: block;
    margin-bottom: 0.3rem;
    background: url('./images/welfare-item-icon.png') no-repeat;
    background-size: 400% 400%;
    transition: transform 0.3s;
  }

  &:hover::before {
    transform: scale(1.2);
  }

  .loop-row(@row) when (@row <= 4) {
    .loop-col(@col) when (@col <= 4) {
      &_@{row}_@{col}::before {
        .sprites-position(352, 352, 88, 88, 88 * (@col - 1), 88 * (@row - 1));
      }
      .loop-col(@col + 1);
    }
    .loop-col(1);
    .loop-row(@row + 1);
  }
  .loop-row(1);
}

.tip {
  .size(18em, 1rem);
  display: none;
  position: absolute;
  top: -1rem;
  left: 50%;
  color: @bubble-color;
  transform: translate(-50%, 0);

  > div {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.12rem 0.2rem;
    border-radius: 0.05rem;
    background-color: @bubble-background-color;
    line-height: 1.8;
  }

  .item:hover & {
    .part-active();
  }

  &::after {
    .size(0.16rem);
    content: '';
    position: absolute;
    bottom: -0.08rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: @bubble-background-color;
    transform: rotate(45deg);
  }
}

@media screen and (max-width: @laptop-width) {
  .tip {
    width: 15em;

    > div {
      font-size: 12px;
    }
  }
}

@media screen and (max-width: @tablet-width) {
  .part {
    .part-zoom(1); // 左右边距各减少 100
  }
}

@media screen and (max-width: @mini-width) {
  .part {
    .part-zoom(2); // 左右边距各减少 200

    // 左侧边
    &::before {
      content: none;
    }

    &:hover {
      // 左侧刻度线
      &::after {
        content: none;
      }
    }

    &_wrap {
      height: auto;
      padding-top: 2rem;
      padding-bottom: 0.75rem;

      .part:not(:last-child) & {
        &::before {
          width: 100%;
        }
      }
    }
  }

  .title {
    .text-show();

    position: absolute;
    top: 0.75rem;
    left: 0;
    background: none;
    font-weight: 700;
    font-size: 14px;
  }

  .item {
    &::before {
      .size(@icon-size * 2);
    }
  }

  .tip {
    width: 10em;

    .item_active & {
      .part-active();
    }
  }
}
</style>
